/* Privacy-safe, vendor-neutral storefront funnel events. */
(function (scope) {
  'use strict';
  var EVENTS = {
    school_search_submitted: ['query_length', 'source', 'action_id'],
    school_store_selected: ['collection_handle', 'product_handle', 'placement', 'action_id'],
    personalization_opened: ['product_handle', 'placement', 'action_id'],
    personalization_saved: ['product_handle', 'placement', 'action_id'],
    add_to_bag: ['product_handle', 'cart_value', 'action_id'],
    checkout_started: ['cart_value', 'action_id']
  };
  var seen = Object.create(null);
  var SENSITIVE = /email|address|commission|payout|api[_-]?key|secret|token|password|customer|phone/i;
  var PLACEMENTS = { finder: true, editorial: true, cta: true, front: true, back: true, 'left sleeve': true, 'right sleeve': true };

  function cleanString(value, max) {
    if (typeof value !== 'string') return null;
    var clean = value.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, max || 120);
    return clean || null;
  }
  function cleanHandle(value) {
    var valueString = cleanString(value, 120);
    return valueString && /^[a-z0-9][a-z0-9_-]*$/i.test(valueString) ? valueString : null;
  }
  function sanitize(eventName, payload) {
    var allowed = EVENTS[eventName];
    if (!allowed || !payload || typeof payload !== 'object' || Array.isArray(payload)) return null;
    var clean = {};
    allowed.forEach(function (key) {
      if (!(key in payload) || SENSITIVE.test(key)) return;
      var value = payload[key];
      if (key === 'query_length') {
        var length = Number(value);
        if (Number.isFinite(length)) clean[key] = Math.max(0, Math.min(100, Math.floor(length)));
      } else if (key === 'cart_value') {
        var cents = Number(value);
        if (Number.isFinite(cents)) clean[key] = Math.max(0, Math.min(100000000, Math.round(cents)));
      } else if (key === 'placement') {
        var placement = cleanString(value, 32);
        if (placement && PLACEMENTS[placement.toLowerCase()]) clean[key] = placement.toLowerCase();
      } else if (key === 'source') {
        var source = cleanString(value, 32);
        if (source && /^[a-z0-9_-]+$/i.test(source)) clean[key] = source;
      } else if (key === 'action_id') {
        var actionId = cleanString(value, 80);
        if (actionId && /^[a-z0-9._:-]+$/i.test(actionId)) clean[key] = actionId;
      } else {
        var handle = cleanHandle(value);
        if (handle) clean[key] = handle;
      }
    });
    return clean;
  }
  function consentAllows() {
    var privacy = scope.Shopify && scope.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.userCanBeTracked !== 'function') return true;
    try {
      var allowed = privacy.userCanBeTracked();
      // Tracking must remain opt-in when a privacy SDK resolves asynchronously;
      // this synchronous helper cannot safely wait for a future consent value.
      if (allowed && typeof allowed.then === 'function') return false;
      return allowed !== false;
    } catch (_) { return false; }
  }
  function track(eventName, payload) {
    var clean = sanitize(eventName, payload);
    if (!clean || !consentAllows()) return false;
    var dedupeKey = clean.action_id ? eventName + ':' + clean.action_id : null;
    if (dedupeKey && seen[dedupeKey]) return false;
    if (dedupeKey) seen[dedupeKey] = true;
    var customerEvents = scope.Shopify && scope.Shopify.customerEvents;
    if (customerEvents && typeof customerEvents.publish === 'function') {
      try { customerEvents.publish(eventName, clean); } catch (_) {}
    }
    if (scope.document && typeof scope.document.dispatchEvent === 'function' && typeof scope.CustomEvent === 'function') {
      try { scope.document.dispatchEvent(new scope.CustomEvent('ghostfit:' + eventName, { bubbles: true, detail: clean })); } catch (_) {}
    }
    return true;
  }
  var api = { track: track, events: Object.keys(EVENTS) };
  if (scope) scope.GhostfitAnalytics = api;
  if (typeof module === 'object' && module.exports) module.exports = { EVENTS: EVENTS, sanitize: sanitize, track: track, create: function (target) { return { track: track.bind(target || scope) }; } };
})(typeof window !== 'undefined' ? window : globalThis);
